import script from "./MindsetPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MindsetPage.vue?vue&type=script&setup=true&lang=js"

import "./MindsetPage.vue?vue&type=style&index=0&id=5b80f0d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b80f0d9"]])

export default __exports__